// convert image to base64 and base64 to image

import { useRef } from "react";
import { useFormikContext } from "formik";

const ConvertIamgeToBase64 = (props) => {
  const { setFieldValue } = useFormikContext();
  const inputFile = useRef(null);
  const onButtonClick = () => {
    inputFile.current.click();
  };

  const handleFileUplaod = async (e) => {
    const base64 = await convertTobase64(e.target.files[0]);
    
    setFieldValue("profilePicture", base64);
  };
  return (
    <div>
      <button
        onClick={onButtonClick}
        className="profile-upload-button"
        type="button"
      >
        <input
          type="file"
          id="file"
          accept={`application/${props.filetype}`}
          ref={inputFile}
          style={{ display: "none" }}
          onChange={(e) => {
            
            if (e.target.files[0].size > 256000) {
              alert("file size must be less than 250kb");
            } else {
              handleFileUplaod(e);
            }
          }}
        />{" "}
        {/* {props.secondaryClass
          ? "Change Photo"
          : props.userUploadProfile
          ? "Upload Photo"
          : "Browse"} */}
        Change Photo
      </button>
    </div>
  );
};
export default ConvertIamgeToBase64;
const convertTobase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};
